import { Component, OnInit } from '@angular/core';
import { Global } from 'src/app/Global';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor(public _global: Global) { }

  ngOnInit() {
  }

}
